import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const indicators = [
    {
      icon: 'Shield',
      title: 'Veilige Toegang',
      description: 'End-to-end encryptie voor alle agent data',
    },
    {
      icon: 'Smartphone',
      title: 'Mobiel Optimaal',
      description: 'Volledige functionaliteit voor veldwerk',
    },
    {
      icon: 'Clock',
      title: 'Real-time Updates',
      description: 'Direct inzicht in leads en commissies',
    },
    {
      icon: 'MapPin',
      title: 'Territorium Beheer',
      description: 'Overzicht van uw toegewezen gebieden',
    },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Agent Portal Voordelen
      </h3>
      <div className="space-y-4">
        {indicators?.map((indicator, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={indicator?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                {indicator?.title}
              </h4>
              <p className="text-sm font-body text-muted-foreground">
                {indicator?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;